export default __webpack_public_path__ + "static/daniel-0f59f0915003d468e456349b81718db4.svg";